import React from 'react';
import { MessageSquare } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { getLanguageDirection } from '../../../i18n/config';

const MessageListLoading: React.FC = () => {
  const { t, i18n } = useTranslation();

  return (
    <div
      dir={getLanguageDirection(i18n.language)}
      className="flex items-center justify-center min-h-[400px] px-4 py-16"
    >
      <div
        className="relative flex flex-col items-center justify-center py-12 px-10 rounded-2xl max-w-[500px] w-full border border-dashed border-gold/20 bg-card/70 overflow-hidden animate-in fade-in duration-500"
      >
        {/* Subtle pulsing background blob */}
        <div className="absolute -top-16 -right-16 w-44 h-44 rounded-full bg-gold/10 animate-pulse pointer-events-none" />

        {/* Icon */}
        <div className="relative z-10 w-16 h-16 rounded-2xl bg-gradient-to-br from-gold/15 to-gold/5 border border-gold/10 shadow-lg flex items-center justify-center mb-8">
          <MessageSquare size={32} strokeWidth={1.5} className="text-gold opacity-80" />
        </div>

        {/* Spinner */}
        <div className="relative w-16 h-16 mb-8">
          <svg
            className="w-16 h-16 animate-spin text-gold"
            viewBox="0 0 64 64"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="32"
              cy="32"
              r="28"
              stroke="currentColor"
              strokeWidth="4"
              strokeLinecap="round"
              strokeDasharray="44 132"
              opacity="0.8"
            />
          </svg>
          {/* Inner ring */}
          <div className="absolute inset-3 rounded-full border border-gold/10" />
        </div>

        {/* Text */}
        <p className="text-lg font-semibold text-foreground tracking-tight text-center mb-1.5">
          {t('common.labels.loading')}
        </p>
        <p className="text-sm text-muted-foreground/75 text-center max-w-xs leading-relaxed">
          {t('components.chats.loading.description')}
        </p>
      </div>
    </div>
  );
};

export default MessageListLoading;
